export default "<div class=\"map-wrapper\">\n  <div #map class=\"map\"></div>\n</div>\n"